import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			closeButton: {
				color: theme.palette.grey[400],
				display: "flex",
				justifyContent: "flex-end",
				webkitJustifyContent: "flex-end"
			},
			customDialog: {},
			body: {
				textAlign: "center",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				flexWrap: "wrap",
				alignItems: "center"
			},
			title: {
				fontSize: 16,
				fontWeight: 400,
				color: theme.palette.common.black,
				marginTop: 10
			},
			subTitle: {
				fontSize: 14,
				fontWeight: 400,
				color: theme.GRAY_FD,
				padding: "5px 10px"
			},
			btnSubmit: {
				color: theme.palette.secondary.main,
				fontSize: 15,
				fontWeight: 400,
				cursor: "pointer",
				padding: 15,
				"&:active": {
					color: theme.palette.secondary.dark
				}
			},
			borderRight: {
				borderRight: `1px solid ${theme.palette.grey[800]}`
			},
			driver: {
				marginTop: 20,
				borderTop: `1px solid ${theme.palette.grey[200]}`,
				width: "100%"
			}
		}),
	{
		name: "DialogInformation",
		index: 1
	}
);

export default useStyles;
